<template>
    <v-layout class="slidebutton">
        <v-flex xs6 text-center class="internal" @click="update" :id="values[0].replace(' ', '_')">
            {{ values[0] }}
        </v-flex>
        <v-flex xs6 text-center class="internal" @click="update" :id="values[1].replace(' ', '_')">
            {{ values[1] }}
        </v-flex>
        <v-flex xs6 text-center class="internal active" :class="{right: !active, disabled}">
            {{ activeText }}
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    name: 'SlideButton',
    props: {
      values: { type: Array, default: () => ['Valor 1', 'Valor 2'] },
      value: Boolean,
      disabled: Boolean
    },
    computed: {
      activeText () {
        return this.values[this.active ? 0 : 1]
      },
      active: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      update () {
        if (!this.disabled) {
          this.active = !this.active
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    $height: 40;
    $gap: 2;
    $border: 1;
    $height_active: $height - 2 * ($gap + $border);

    .slidebutton {
        border: solid #{$border}px var(--gray);
        color: var(--darkgray);
        height: #{$height}px;
        text-transform: uppercase;
        position: relative;
        cursor: pointer;
        border-radius: #{$height/2}px;

        .internal {
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-weight: bold;
            font-size: 12px;
            margin-top: #{$gap}px;
            height: #{$height_active}px;
            border-radius: #{$height_active/2}px;

            &.active {
                position: absolute;
                margin-left: #{$gap}px;
                width: calc(50% - #{$gap}px);
                color: white;
                background-color: var(--primary);
                transition: all 500ms ease;

                &.right {
                    margin-left: 50%;
                }

                &.disabled {
                    background-color: var(--dark);
                }
            }
        }
    }
</style>
